/**
 * 框架标准接口，页面渲染前的数据处理
 *
 * 约等于接口拦截
 */
import interceptorsModule from '@/config/interceptors'
export default {
  // 列表初始化（按钮、查询表单、图例等）
  getTableQuery: async function (res) {
    const { data: { datas, tabcmd } } = res

    // ------ 双击不要进详情：------
    const noObjectView = ['V_SG_B_STO_STORE_DISTRIBUTION','V_COMMODITY_OPERATING_STATEMENT']
    if (noObjectView.includes(datas.table)) {
      tabcmd.prem[9] = false
    }

    // ------ 导出按钮展示：------
    const showExportTabArr = ['V_RPT_SOURCE_ORDER_DETAILS_QUERY', 'V_RPT_SOURCE_REFUND_DETAILS_QUERY', 'V_RPT_SOURCE_RETURN_DETAILS_QUERY']
    if (showExportTabArr.includes(datas.table)) {
      tabcmd.prem[8] = true
    }
    // ------ 平台店铺档案-defined字段列表处理：------
    if (datas.table == 'CP_C_SHOP') {
      let x = datas.dataarry.findIndex(it => it.colname == 'IS_EQUAL_EXCHANGE')
      if (x != -1) {
        datas.dataarry[x] = {
          "coldesc": t("对等换货"),
          "colname": "IS_EQUAL_EXCHANGE",
          "isuppercase": false,
          "display": "OBJ_SELECT",
          "webconf": null,
          "colid": 1700840472,
          "type": "STRING",
          "combobox": [
            {
              "limitdesc": t("是"),
              "limitdis": true,
              "limitval": "Y"
            },
            {
              "limitdesc": t("否"),
              "limitdis": false,
              "limitval": "N"
            }
          ]
        }
      }
    }
    //  ------ 商品品类 - 商品名称 defined处理：------
    /* if (datas.table == 'PS_C_CATEGORY') {
      let x = datas.dataarry.findIndex(it => it.colname == 'CATEGORY_NAME')
      if (x != -1) {
        datas.dataarry[x] = {
          "coldesc": "类目名称",
          "colname": "CATEGORY_NAME",
          "isuppercase": false,
          "webconf": null,
          "colid": 1700847742,
          "display": "defined",
          "type": "STRING"
        }
      }
    } */
    //  ------ 商品品类 defined处理：------
    interceptorsModule.category.handleStandardListFormDefined(datas)

    // ------ 权限页面按钮展示：------
    const permission = interceptorsModule.permission.hideBtn(res)
    res.data.tabcmd = { ...res.data.tabcmd, prem: permission.prem }
    permission.waListButtons && (res.data.waListButtons = permission.waListButtons)

    return res
  },
  // 列表数据查询（分页、表头、表格数据填充等）
  QueryList: async function (res) {
    // debugger
    const { data: { datas: { row, tabth, tabname } } } = res
    if (!row || (row && !row.length)) {
      res.data.datas.isFullRangeSubTotalEnabled = false
      res.data.datas.isSubTotalEnabled = false
    }
    if (tabname == 'PS_C_PRO_SN') {
      const dex = tabth.findIndex(i => i.colname == 'JSON_DATA')
      tabth.splice(dex, 1)
      vm.$store.commit("omsStore/up_PS_C_PRO_SN_CUSTOM_TABLE_DATA", JSON.parse(row[0].JSON_DATA.val));
    }
    // ------ 商品效期策略、寻源前拆单策略、商品基本属性、商品销售属性、商品品类-展示ID列：------
    const QueryListTables = new Map([
      ['ST_C_EXPIRY_DATE', t('策略ID')],
      ['ST_C_SPLIT_BEFORE_SOURCE_STRATEGY', t('策略ID')],
      ['PS_C_PRODIM', t('属性ID')],
      ['PS_C_SALES_INFO', t('属性ID')],
      ['PS_C_CATEGORY', t('类目ID')],
    ])
    if ([...QueryListTables.keys()].includes(tabname)) {
      const _idIt = JSON.parse(JSON.stringify(tabth[0]))
      _idIt.colname = '_ID'
      _idIt.name = QueryListTables.get(tabname)
      _idIt.type = 'STRING'
      tabth.splice(0,0,_idIt)
      row.forEach(it => {
        it._ID = it.ID
      });
    }
    // ------ 调整页码：------
    const changePageTab = [
      'AC_F_COMMON_ORIGINAL_BILL','AC_F_ALIPAY_BILL_RAW_DATA','AC_F_PDD_ORIGINAL_BILL',
      'AC_F_DOUYIN_ORIGINAL_BILL','AC_F_CONFIRM_PLATFORM_BILL','AC_F_CONFIRM_BILL'
    ]
    const newRange = [ 10, 20, 30, 50, 100, 200, 500, 1000, 2000 ]
    if (changePageTab.includes(tabname)) {
      res.data.datas.selectrange = newRange
    }
    // ------ 平台店铺档案：------
    /* if (tabname == "CP_C_SHOP") {
      row.forEach(it => {
        if(it.IS_EQUAL_EXCHANGE.val) it.IS_EQUAL_EXCHANGE.val = it.IS_EQUAL_EXCHANGE.val == "Y" ? t('是') : t('否')
      });
    } */

    // res.data.datas.isFullRangeSubTotalEnabled = false // 关闭'总计'

    return res
  }
}
